import { render, staticRenderFns } from "./StorageRecipientSearchDialog.vue?vue&type=template&id=31d9ffa6&scoped=true&"
import script from "./StorageRecipientSearchDialog.vue?vue&type=script&lang=js&"
export * from "./StorageRecipientSearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./StorageRecipientSearchDialog.vue?vue&type=style&index=0&id=31d9ffa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9ffa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRadio,VRadioGroup,VRow,VSpacer})
